












import Vue from "vue";
import { gameStore } from "../store/game/store";
import _ from "lodash";
export default Vue.extend({
  data() {
    return {
      visible: true
    };
  },
  computed: {
    playerLeft() {
      return _.find(
        gameStore.state.players,
        p => p.id == gameStore.state.playerLeft
      )?.name;
    }
  }
});
